import axios from "../api/axios";
import config from '../config/configJS';

function SendData(data, path) {
  var promise = new Promise(function (resolve, reject) {
    axios
      .post(config.endPoint + path, JSON.stringify(data), {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        withCredentials: true
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });

  return promise;
}

export function getUserById(id) {
  return new Promise((resolve, reject) => {
    SendData({ 'id': id }, 'api/auth/GetById')
      .then((data) => {
        resolve(data); 
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
}

export function authenticateUser(UserEmail, Password) {
  return new Promise((resolve, reject) => {
    SendData(
      {
        UserEmail: UserEmail,
        Password: Password,
      },
      'api/auth/Authenticate'
    )
      .then((data) => {
        resolve(data); 
      })
      .catch((err) => {
        console.log(err);
        reject(err); 
      });
  });
}

export function registerUser(fName, lName, email, pwd, roleId, teams) {
  return SendData({
        "Firstname": fName,
        "Lastname": lName,
        "UserEmail": email,
        "Password": pwd,
        "RoleId": roleId,
        "TeamIds" : teams
      }, '/api/auth/Register');
}

export function getAllUsers() {
  return new Promise((resolve, reject) => {
    axios
      .get(config.endPoint + '/api/auth/GetAll', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Methods': 'GET',
        },
        withCredentials: true
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function updateUser(id, fName, lName, pwd, roleId, teamIds) {
  return SendData({
    "Id": id,
    "FirstName": fName,
    "LastName": lName,
    "Password": pwd,
    "RoleId": roleId,
    "TeamIds" : teamIds
  }, '/api/auth/UpdateUser');
}

export function searchUsers (name) {
  return SendData({ 
    "FirstName" : name,
  }, '/api/auth/GetByName');
}

export function deleteUser(id) {
  return SendData({
    "Id": id
  }, '/api/auth/DeleteUserById');
}

export function getAllRoles() {
  return new Promise((resolve, reject) => {
    axios
      .get(config.endPoint + '/api/auth/GetAllRoles', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Methods': 'GET',
        },
        withCredentials: true
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function createTeam (name, userIds, envIds) {
  return SendData({
    "Name": name,
    "UserIds": userIds,
    "EnvIds" : envIds
  }, '/api/auth/CreateTeam');
}

export function updateTeam (id, name, userIds, envIds) {
  return SendData({
    "Id": id,
    "Name": name,
    "UserIds": userIds,
    "EnvIds" : envIds
  }, '/api/auth/UpdateTeam');
}

export function deleteTeam(id) {
  return SendData({
    "Id": id
  }, '/api/auth/DeleteTeam');
}

export function getTeamById (id) {
  return SendData({
    "Id": id
  },'/api/auth/GetTeamById');
}

export function isTokenValid(token) {
  if (token === undefined) {
    return false;
  } else {
    const dateToCompare = new Date(token.expires);
    const currentDate = new Date();
    const currentDatePlus2Hours = new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);
    if (dateToCompare > currentDatePlus2Hours) {
      return false;
    }
  }
  return true;
}
